// extracted by mini-css-extract-plugin
export default {"sizesStock":"CallForStockAvailability-sizesStock-EnY","notify":"CallForStockAvailability-notify-xKW"};